const AUTH_TOKEN_KEY = 'mindvrik_auth_token';
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api';

const request = async (path, options = {}) => {
  const token = window.localStorage.getItem(AUTH_TOKEN_KEY);
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch (error) {
    payload = null;
  }

  if (!response.ok) {
    throw new Error(payload?.detail || payload?.message || 'Request failed. Please try again.');
  }
  return payload;
};

const toDateString = (date) => date.toISOString().slice(0, 10);

export const counsellingService = {
  getBookableDates(days = 14) {
    const dates = [];
    const cursor = new Date();
    cursor.setDate(cursor.getDate() + 1);

    while (dates.length < days) {
      if (cursor.getDay() !== 0) {
        dates.push(toDateString(cursor));
      }
      cursor.setDate(cursor.getDate() + 1);
    }

    return dates;
  },

  async fetchSlots({ expertId, date }) {
    const params = new URLSearchParams({ expertId, date });
    return request(`/counselling/slots?${params.toString()}`);
  },

  async createBooking({ expert, date, time, sessionType, notes }) {
    return request('/counselling/bookings', {
      method: 'POST',
      body: JSON.stringify({
        expertId: expert.id,
        expertName: expert.name,
        date,
        time,
        sessionType,
        notes,
      }),
    });
  },

  async listBookings() {
    return request('/counselling/bookings');
  },

  async updateBookingStatus({ bookingId, status }) {
    return request(`/counselling/bookings/${bookingId}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ status }),
    });
  },

  async rescheduleBooking({ bookingId, date, time }) {
    return request(`/counselling/bookings/${bookingId}/reschedule`, {
      method: 'PATCH',
      body: JSON.stringify({ date, time }),
    });
  },
};
